import { config } from '@/config'

/** Get the full dashboard URL for a registry schema */
export function schemaDashboardUrl(uid: string) {
  return `${config.projects.dashboard}/schemas/${uid}`
}
